/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#operation-hashes)
 */
export const operationHashes = {
  "adminToolbar": "_R2mbdxOJd",
  "drupalUser": "sNc-Q0VM7u",
  "getEventTeasers": "ZVnzh9cgHq",
  "getIntegrationProgramTeasers": "RPRKbQVXM8",
  "getPressReleaseTeasers": "GGhVPttG-p",
  "initData": "S_lyNTj8oR",
  "loadTranslations": "6wXqv-dZ77",
  "localTasks": "4KpYWXogBj",
  "paragraphsLibraryItem": "DMEWLNHSSD",
  "pbAddClipboardText": "XZgdhd3dIK",
  "pbAddComment": "ndl0-MmxVg",
  "pbAddEntityReference": "iGBMQVbOfx",
  "pbAddEntityReferenceMultiple": "5K0nWj5oww",
  "pbAddFile": "w1z92376DM",
  "pbAddFragmentParagraph": "OlVrjjWdXG",
  "pbAddImage": "Cb-ZnuunuR",
  "pbAddParagraph": "U7-FqE0Ggw",
  "pbAddReusableParagraph": "TJSZweIh-w",
  "pbAddVideoRemote": "CN2dOCFLmX",
  "pbApplyTransformPlugin": "6AMxx6bI2L",
  "pbBulkUpdateParagraphBehaviorSettings": "UkCD7H52bD",
  "pbComments": "eLhHrN5PPt",
  "pbConfig": "S8qpiEegF_",
  "pbConversions": "hIb-h-hpru",
  "pbConvertMultiple": "AUFaYZlW28",
  "pbConvertParagraph": "CrfXcCbZYY",
  "pbCopyFromExisting": "MmyUhI8I5y",
  "pbDeleteMultipleParagraphs": "D_eiZ4hd1u",
  "pbDeleteParagraph": "IXYRwRyuL-",
  "pbDetachReusableParagraph": "fDHw_4xDWb",
  "pbDuplicateMultipleParagraphs": "R0rmHu3JbK",
  "pbDuplicateParagraph": "yD5wYSPqVy",
  "pbEditState": "6NTljvVRSt",
  "pbGetImportSourceEntities": "va6PnAMoeJ",
  "pbGetPreviewGrantUrl": "sAJOzxHeUi",
  "pbGetTransformPlugins": "qa4M4JfbbI",
  "pbLibraryItems": "PD518AP7-R",
  "pbMakeParagraphReusable": "V370zJJOQ2",
  "pbMediaLibraryGetResults": "gA3YxwjAUh",
  "pbMoveMultipleItems": "FTiU2BTFfj",
  "pbMoveParagraph": "UPYjpFuQeM",
  "pbPublish": "5_JnXaQggp",
  "pbRedo": "YAv9UKoe1V",
  "pbReplaceHostEntityMedia": "DHMOpJAlGW",
  "pbReplaceMedia": "ipu2BaC7eh",
  "pbResolveComment": "gAt359uTiN",
  "pbRevertAllChanges": "Z20xmCAflX",
  "pbSearch": "gZi3jFPAyy",
  "pbSearchTabs": "3jxTsFlHH7",
  "pbSetHistoryIndex": "ua8PFlqc4X",
  "pbSetMutationItemStatus": "un65_AGAWv",
  "pbTakeOwnership": "XvZsdZLL2p",
  "pbUndo": "Mqi55dRkyv",
  "pbUpdateFieldValue": "MpIusbCPKP",
  "pbUpdateHostEntityFieldValue": "0qUK4kgD6b",
  "pbUpdateParagraphOption": "oGACHbhFW_",
  "routeNodeCanonical": "Zt38x3bHSv",
  "routeNodeContact": "ewBnV5vRWE",
  "routeNodeEvent": "d80Op2-QY9",
  "routeNodePage": "re2IBXYCql",
  "routeNodePressRelease": "UH-hM27s1B",
  "routeSlug": "HEG7XlBXWY",
  "routeWebform": "tPCz9OyXvU",
  "submitWebform": "XNaYi42PQP",
  "webformConfirmation": "GCKVdyHElr"
}